import { render } from "./MarketingDatatableTDGroupTitle.vue?vue&type=template&id=60680234"
import script from "./MarketingDatatableTDGroupTitle.vue?vue&type=script&lang=js"
export * from "./MarketingDatatableTDGroupTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__